import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GoogleChartsModule } from 'angular-google-charts';
import { ChartType } from 'angular-google-charts';

@Component({
  selector: 'app-more-info-modal',
  standalone: true,
  imports: [GoogleChartsModule],
  templateUrl: './more-info-modal.component.html',
  styleUrl: './more-info-modal.component.scss'
})
export class MoreInfoModalComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef);
  description = '';
  liArray: string[] = [];
  chartData: any[] = [];
  chartOptions = {
    title: '',
    pieHole: 0.6,
    legend: {
      position: 'bottom'
    }
  }
  chartType: ChartType = ChartType.PieChart;

  ngOnInit(): void {
    if (this.data.process === 'Agricultura') {
      this.description = 'A Acelen conduz todo o ciclo de cultivo da macaúba em seu Centro de Inovação Tecnológica Agroindustrial (Agripark) em MontesClaros (MG), desde a germinação de sementes até a produção de mudas, usando práticas sustentáveis de gestão ambiental e de cultivo. As áreas degradadas são mapeadas para identificar maciços com maior potencial de produção de óleo, depois formam-se bancos de germoplasma para seleção das melhores plantas, clonagem e aprimoramento genético.';
      this.liArray = ['Restauração de solos degradados em áreas de sequestro de carbono, melhorando estrutura e matéria orgânica do solo.', 'Adoção de protocolos próprios de germinação e ensaios controlados que elevam a taxa de sucesso na produção de mudas.', 'Uso de processos automatizados e robotizados que reduzem perdas e custos operacionais', 'Fortalecimento de agricultura familiar e pequenos produtores via pesquisa aplicada e geração de mudas.'];
      if(this.data.stage) {
        this.data.stage.inputs.forEach((input: any) => {
          this.chartData.push([(input.name).toUpperCase(), this.calculateInputFootPrint(input.documents)])
        });        
      }
    }
    if (this.data.process === 'Moagem') {
      this.description = 'No Agripark, a fase de moagem (extração de óleo) ocorre em uma planta-piloto onde sementes de macaúba são trituradas e prensadas em uma unidade de extração dedicada. Em seguida, óleo e coprodutos são submetidos a ensaios de caracterização e processamento para validar qualidade e rendimento.';
      this.liArray = ['Planta-piloto possibilita domínio tecnológico antes da escala industrial, reduzindo riscos de operação.', 'Unidade de extração projetada para flexibilidade de matérias-primas, permitindo testes com diferentes sementes e coprodutos.', 'Ensaios de processamento garantem controle de qualidade do óleo bruto e dos coprodutos, otimizando o rendimento global.'];
      if(this.data.stage) {
        this.data.stage.inputs.forEach((input: any) => {
          this.chartData.push([(input.name).toUpperCase(), this.calculateInputFootPrint(input.documents)])
        });        
      }
    }
    if (this.data.process === 'Refinaria') {
      this.description = 'A biorrefinaria da Acelen, instalada junto à Refinaria de Mataripe (BA), adota processo HEFA (hydroprocessed esters and fatty acids), semelhante à refinaria convencional de diesel e querosene de aviação, mas preparada para processar óleos vegetais (macaúba, soja), óleo usado e gorduras animais. O resultado são HVO (diesel renovável) e SAF (combustível sustentável de aviação) 100% drop-in.';
      this.liArray = ['Combustíveis “drop-in” que não exigem modificações em motores, turbinas ou infraestrutura de distribuição.', 'Potencial de redução de até 80% nas emissões de CO₂ “well-to-wheel” em comparação a fósseis.', 'Flexibilidade para uso de múltiplos feedstocks (macaúba, soja certificada, resíduos) durante a maturação das plantações.', 'Integração de parque solar para auto-suprimento de energia, diminuindo ainda mais a pegada de carbono.'];
      if(this.data.stage) {
        this.data.stage.inputs.forEach((input: any) => {
          this.chartData.push([(input.name).toUpperCase(), this.calculateInputFootPrint(input.documents)])
        });        
      }
    }
    if (this.data.process === 'Logísticas de Saída') {
      this.description = 'A unidade de Mataripe aproveita a infraestrutura da refinaria existente, com terminais de armazenamento e distribuição integrados, garantindo escoamento eficiente dos biocombustíveis para mercados no Brasil, EUA, Canadá e Europa. Toda a cadeia – da semente ao combustível – é rastreada por tecnologias de Agricultura 4.0, assegurando compliance e transparência.';
      this.liArray = ['Proximidade entre áreas de cultivo e refinaria reduz custos e emissões no transporte de matéria-prima', 'Uso de terminais já existentes na Refinaria de Mataripe acelera início de operações e minimiza investimentos adicionais.', 'Rastreabilidade completa fortalece credibilidade junto a certificações ESG e clientes internacionais.', 'Capacidade planejada para atender 1 bilhão de litros/ano, suportando demanda global por combustíveis limpos.'];
      if(this.data.stage) {
        this.data.stage.inputs.forEach((input: any) => {
          this.chartData.push([(input.name).toUpperCase(), this.calculateInputFootPrint(input.documents)])
        });        
      }
    }
  }

  calculateInputFootPrint(footPrints: any[]): number {
    let footPrintsSum = 0;
    footPrints.forEach((item: any) => {
      if(footPrintsSum != 0) {
        footPrintsSum = footPrintsSum + item.footPrint;
      } else {
        footPrintsSum = item.footPrint
      }
    });
     return footPrintsSum;
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
